import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  margin-top: 20px;
  flex-shrink: 0;
`;

export default Container;
